import React from 'react'
import styled from 'styled-components'
import paystackLogo from "../../assets/images/paystack-logo.svg"
import TermsOfService from '../../pages/LegalTerms';
import { Link } from 'react-router-dom'

export const BottomSection = () => {
    return (
        <StyledBottomSection className='bottom-field'> 
            <div className='bottom-content'> 
                <div className='powered-section'>
                    <h5>powered by</h5> 
                    <a href="https://paystack.com/"> 
                        <img 
                            className="logo" 
                            src={paystackLogo} 
                            height={22} 
                            alt="Paystack Logo" 
                        /> 
                    </a>
                </div>
                <div className='links-section'>
                    <Link to="/legal/terms-of-use">Terms of Use</Link> 
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
            </div>
        </StyledBottomSection>
    );
};

const StyledBottomSection = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 15vh;
    padding: 0 1rem;

    .bottom-content {
        margin-top: 4em;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        width: 100%;

        .powered-section {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;

            h5 {
                margin: 0;
                font-size: 0.9em;
                color: #777777;
            }

            .logo {
                height: 20px;
            }
        }

        .links-section {
            display: flex;
            justify-content: center;
            gap: 1rem;

            a {
                font-size: 0.8em;
                color: #777777;
                text-decoration: none;
            }
        }
    }

    @media only screen and (min-width: 585px){
        .bottom-content {
            margin-top: 3em;
        }
    }
`;

export default BottomSection;